import { TabPanel } from '@mui/lab';
import Box from '@mui/material/Box';
import { TextareaAutosize } from '@mui/material';


export const TabInformacoes = ({values} : {values: any}) => {

  return (
    <TabPanel value='8'>
      <Box className='grid grid-cols-8 gap-7 pt-4'>
        <Box className={'grid grid-cols-8 col-span-4 border-base-base border-2 p-2 rounded-lg text-md'}>
          <TextareaAutosize disabled={true} className={'col-span-8'} minRows={12} value={values?.nfeProc?.NFe?.infNFe?.infAdic?.infCpl}/>
        </Box>
      </Box>
    </TabPanel>
  )
}